<template>
  <Container>
    <Title
      strong
      bold
    >
      {{ donationPeriod }}
    </Title>

    <Form>
      <FormCard>
        <BreadCrumb :items="breadCrumbitems" />
        <FormHeading>
          {{ steps.DONATION_CONFIRM }}
        </FormHeading>

        <FormRow>
          <PreviewSectionTitle>捐款資訊</PreviewSectionTitle>
        </FormRow>

        <template>
          <FormRow>
            <PreviewField
              v-for="(item,index) in formattedDonationInfo"
              :key="index"
              :name="item.name"
              :value="item.value"
            />
          </FormRow>
        </template>

        <FormRow>
          <PreviewSectionTitle>捐款人資訊</PreviewSectionTitle>
        </FormRow>

        <template v-if="isAnonymous">
          <template>
            <FormRow>
              <PreviewField
                v-for="(item,index) in anonymousFields"
                :key="index"
                :name="item.name"
                :value="item.value"
              />
            </FormRow>
          </template>
        </template>

        <template v-else-if="!isAnonymous && !isGroup">
          <FormRow>
            <PreviewField
              v-for="(item,index) in singleFields"
              :key="index"
              :name="item.name"
              :value="item.value"
            />
          </FormRow>
        </template>

        <template v-else-if="!isAnonymous && isGroup">
          <FormRow>
            <PreviewField
              v-for="(item,index) in groupFields"
              :key="index"
              :name="item.name"
              :value="item.value"
            />
          </FormRow>
        </template>

        <template v-if="!isAnonymous">
          <FormRow>
            <PreviewSectionTitle>收據資訊</PreviewSectionTitle>
          </FormRow>
          <template>
            <FormRow>
              <PreviewField
                v-for="(item,index) in receiptFields"
                :key="index"
                :name="item.name"
                :value="item.value"
              />
            </FormRow>
          </template>
        </template>

        <template v-if="!isAnonymous">
          <FormRow>
            <PreviewSectionTitle>其他</PreviewSectionTitle>
          </FormRow>
          <template>
            <FormRow>
              <PreviewField
                v-for="(item,index) in otherFields"
                :key="index"
                :name="item.name"
                :value="item.value"
              />
            </FormRow>
          </template>
        </template>

        <br>
        <br>
        <Align center>
          <Button
            back
            @click.native="back"
          >
            上一步
          </Button>
          <Button
            @click.native="submit"
          >
            確認
          </Button>
        </Align>
      </FormCard>
    </Form>
  </Container>
</template>

<script>
import _ from 'lodash';
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import { saveStore } from '@/lib/storage';
// configs
import steps from '@/configs/steps';
import donationPeriodType from '@/configs/donationPeriod';
// components
import Container from '../../components/layout/Container';
import Align from '../../components/layout/Align';
import Title from '../../components/Title';
import Form from '../../components/form/Form';
import FormCard from '../../components/form/FormCard';
import FormHeading from '../../components/form/FormHeading';
import FormRow from '../../components/form/FormRow';
import Button from '../../components/buttons/Button';
import PreviewSectionTitle from '../../components/preview/PreviewSectionTitle';
import PreviewField from '../../components/preview/PreviewField';
import BreadCrumb from '../../components/others/BreadCrumb';

export default {
  components: {
    Container,
    Align,

    Title,

    Form,
    FormCard,
    FormHeading,
    FormRow,

    Button,

    PreviewSectionTitle,
    PreviewField,

    BreadCrumb,
  },

  data() {
    return {
      steps: Object.freeze(steps),
      donationPeriodType: Object.freeze(donationPeriodType),
      createdNewOpportunity: false,
    };
  },

  computed: {

    formattedDonationInfo() {
      return _.filter(this.donationInfo, item => item.value);
    },

    ...mapState({
      donationPeriod: state => state.donation.donationPeriod,
      breadCrumbitems: state => state.breadCrumb.items,
    }),

    ...mapGetters('donation', [
      'isGroup',
      'isAnonymous',
      'donationInfo',
      'receiptFields',
      'singleFields',
      'groupFields',
      'anonymousFields',
      'otherFields',
    ]),

    ...mapGetters('ui', [
      'isMobile',
    ]),

    ...mapFields('donation/ECPay', {
      orderId: 'oppoId',
    }),

  },

  mounted() {
    this.updateStep('2');
  },

  methods: {
    ...mapMutations({
      updateStep: 'breadCrumb/updateStep',
    }),

    ...mapActions('donation', [
      'createSingleDonate',
      'createRegularDonate',
    ]),

    back() {
      this.$router.push({ name: this.donationPeriod === donationPeriodType.DONATION_SINGLE ? 'single-info' : 'period-info' });
    },

    async submit() {
      const loader = this.$loading.show();
      if(this.donationPeriod === donationPeriodType.DONATION_SINGLE) {
        const isCreated = await this.createSingleDonate();
        if(isCreated) {
          saveStore();
          loader.hide();
          this.$router.push({ name: 'single-payment' });
        }
      }

      if(this.donationPeriod === donationPeriodType.DONATION_PERIOD) {
        const isCreated = await this.createRegularDonate();
        if(isCreated) {
          saveStore();
          loader.hide();
          this.$router.push({ name: 'period-payment' });
        }
      }
    },
  },
};

</script>
